import { useState, useEffect } from "react";
import { Tabs } from "antd";
import WordTab from "./WordTab/WordTab";
import styled from "styled-components"
import ConstituentFalseTab from "./ConstituentFalseTab/ConstituentFalseTab";
import ImageTab from "./ImageTab/ImageTab";
import PromptTab from "./PromptTab/PromptTab"
import axios from "axios";

const backend = process.env.REACT_APP_BACKEND;
const StyledTabs = styled((props)=> <Tabs {...props} />)`
  .ant-tabs-content {
    display: flex;
    height: 100%;
  }
  .ant-tabs-content > .ant-tabs-tabpane {
    width: 100%;
  }
  .ant-tabs-tabpane > div > div > div {
    display: flex;
    flex-direction: column;
  }
`

function NewWord () {
  const [baseParams, setBaseParams] = useState({
    search: "",
    pos: "all",
    cefrLevelByEVP: "all",
    cefrLevelByGPT: "all",
    wordCount: "all",
    imageCount: "all",
    language: "L0010",
  })
  const [languageGroup, setLanguageGroup] = useState([])
  const [pos, setPos] = useState([])

  const baseParamsHandler = (newBaseParams) => {
    setBaseParams(newBaseParams)
  }

  const items = [
    {
      key: "1",
      label: "단어",
      children: 
        <WordTab
          baseParams = {baseParams}
          baseParamsHandler = {baseParamsHandler}
          pos = {pos}
        />
    },
    {
      key: "2",
      label: "해석&오답",
      children: 
        <ConstituentFalseTab
          baseParams = {baseParams}
          baseParamsHandler = {baseParamsHandler}
          pos = {pos}
          languageGroup={languageGroup}
        />
    },
    {
      key: "3",
      label: "이미지",
      children: 
        <ImageTab
          baseParams = {baseParams}
          baseParamsHandler = {baseParamsHandler}
          pos = {pos}
        />
    },
    {
      key: "4",
      label: "프롬프트",
      children: <PromptTab />
    },
  ]

  const getBaseGroupHandler = async () => {
    const baseGroup = await axios.get(`${backend}/contents/new_word/${baseParams.language}`)
    setPos(baseGroup.data.data[0])
    setLanguageGroup(baseGroup.data.data[1])
  }

  useEffect(()=>{
    getBaseGroupHandler()
  },[])

  return (
    <div style={{height:"100%", width:"100%", display:"flex"}}>
      <StyledTabs
        defaultActiveKey="1"
        destroyInactiveTabPane={true}
        items={items}
        type="card"
        size="small"
        style={{width:"100%"}}
      >

      </StyledTabs>
    </div>
  )
}

export default NewWord